import { t } from "i18next";
import { useCallback } from "react";
import { ContractNotificationTypeDto } from "../../autogen/bff-api";

export const useDisplayNotificationEvent = () => {
  const displayNotificationEvent = useCallback((type: ContractNotificationTypeDto): string => {
    switch (type) {
      case ContractNotificationTypeDto.EndDateReminder:
        return t("End date reminder");
      case ContractNotificationTypeDto.RenewalDateReminder:
        return t("Renewal date reminder");
      case ContractNotificationTypeDto.WarrantyExpirationDateReminder:
        return t("Warranty expiration date reminder");
      case ContractNotificationTypeDto.StartDateReminder:
        return t("Start date reminder");
      case ContractNotificationTypeDto.TerminationDateReminder:
        return t("Termination date reminder");
      case ContractNotificationTypeDto.NoticePeriodReminder:
        return t("Notice period reminder");
      case ContractNotificationTypeDto.OptionExecutionDeadlineReminder:
        return t("Option execution deadline reminder");
      case ContractNotificationTypeDto.OptionStartDateReminder:
        return t("Option start date reminder");
      case ContractNotificationTypeDto.NoEndDateReminder:
        return t("Contract without end date reminder");
    }
  }, []);

  return displayNotificationEvent;
};
